import script from "./BikeScienceWeb.vue?vue&type=script&setup=true&lang=js"
export * from "./BikeScienceWeb.vue?vue&type=script&setup=true&lang=js"

import "./BikeScienceWeb.vue?vue&type=style&index=0&id=4d11c7a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d11c7a2"]])

export default __exports__